import ClassroomsResumeTooltip from "./ClassroomsResumeTooltip";

export default ClassroomsResumeTooltip;
